import { makeVar, ReactiveVar } from "@apollo/client";

// Define the structure of the chart state
interface ChartState {
    hoveredIndex: number | null;
    colors: string[];
    colorsHorizontal: string[];
}

// Create the reactive variable with the defined structure
const chart: ReactiveVar<ChartState> = makeVar<ChartState>({
    hoveredIndex: null,
    colors: [
        "#CCEBF5",
        "#99D6EB",
        "#66C2E0",
        "#33ADD6",
        "#09C",
        "#007AA3",
        "#005C7A",
        "#33336B",
        "#000031",
    ],
    colorsHorizontal: ["#CCEBF5", "#000031"],
});

export default chart;
